import { takeLatest, put, select, call } from "redux-saga/effects";
import { createAction } from "redux-actions";
import dayjs from "dayjs";
import axios from "axios";
import { queryParams } from "../../../../utils/queryParams";

export const SET_LOADING = "saga/leadActivity/SET_LOADING";
export const SET_UPDATES_LOADING = "saga/leadActivity/SET_UPDATES_LOADING";
export const SET_DATES = "saga/leadActivity/SET_DATES";
export const SET_FILTERS_DIRTY = "saga/leadActivity/SET_FILTERS_DIRTY";
export const SET_FILTER_BY_INDEX = "saga/leadActivity/SET_FILTER_BY_INDEX";
export const SET_START_FROM_BY_INDEX = "saga/leadActivity/SET_START_FROM_BY_INDEX";
export const SET_HIDE_ACTIONS = "saga/leadActivity/SET_HIDE_ACTIONS";
export const SET_START_FROM = "saga/leadActivity/SET_START_FROM";
export const SET_TABLE_LOADING = "saga/leadActivity/SET_TABLE_LOADING";
export const SET_FILTERS_LOADING = "saga/leadActivity/SET_FILTERS_LOADING";
export const SET_MAIN_FILTER_LOADING = "saga/leadActivity/SET_MAIN_FILTER_LOADING";

const FETCH_CURRENT_USER = "saga/leadActivity/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/leadActivity/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_FILTER_BY_INDEX_SUCCESS = "saga/leadActivity/FETCH_FILTER_BY_INDEX_SUCCESS";
export const FETCH_TABLE_DATA = "saga/leadActivity/FETCH_TABLE_DATA";
export const FETCH_MAIN_FILTER_SUCCESS = "saga/leadActivity/FETCH_MAIN_FILTER_SUCCESS";
export const FETCH_TABLE_DATA_SUCCESS = "saga/leadActivity/FETCH_TABLE_DATA_SUCCESS";

export const UPDATE_FILTER_BY_INDEX = "saga/leadActivity/UPDATE_FILTER_BY_INDEX";
export const UPDATE_MAIN_FILTER = "saga/leadActivity/UPDATE_MAIN_FILTER";
export const CREATE_FILTERS_GROUP = "saga/leadActivity/CREATE_FILTERS_GROUP";
export const ADD_FILTERS_GROUP = "saga/leadActivity/ADD_FILTERS_GROUP";
export const REMOVE_FILTERS_GROUP = "saga/leadActivity/REMOVE_FILTERS_GROUP";
export const RESET_FILTERS = "saga/leadActivity/RESET_FILTERS";
export const CHANGE_ORDER = "saga/leadActivity/CHANGE_ORDER";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateTable: createAction(FETCH_TABLE_DATA),
  resetFilters: createAction(RESET_FILTERS),
  addFiltersGroup: createAction(ADD_FILTERS_GROUP),
  updateFilterByIndex: createAction(UPDATE_FILTER_BY_INDEX),
  removeFiltersGroup: createAction(REMOVE_FILTERS_GROUP),
  updateMainFilter: createAction(UPDATE_MAIN_FILTER),
  setHideActions: createAction(SET_HIDE_ACTIONS),
  changeOrder: createAction(CHANGE_ORDER)
};

export default function* watchLeadStatus() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeLatest(FETCH_TABLE_DATA, fetchTableData);
  yield takeLatest(UPDATE_FILTER_BY_INDEX, updateFilterByIndex);
  yield takeLatest(UPDATE_MAIN_FILTER, updateMainFilter);
  yield takeLatest(ADD_FILTERS_GROUP, addFiltersGroup);
  yield takeLatest(RESET_FILTERS, fetchMainFilter);
}

const API_PATH = "pages/sales_activity/lead_activity";

function* fetchCurrentUserData({ payload }) {
  try {
    yield put({ type: SET_LOADING, payload: true });

    if (!payload.showModule) {
      yield put({ type: SET_LOADING, payload: false });
      return;
    }
    yield put({
      type: FETCH_CURRENT_USER_SUCCESS,
      payload
    });

    yield setDates(payload.calendarEndDate);

    yield fetchMainFilter();
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function prepareQueryParams(input) {
  const normalize = (filters, index) => {
    const params = {
      index,
      action: filters.start_from?.id,
      filter_by: filters.filter_by?.id || null,
      filter_by_values: filters.filter_by_values?.map((val) => val.id) || [],
      end_date: filters.selectedRequestDates.endDate,
      start_date: filters.selectedRequestDates.startDate
    };

    if (filters.date_by?.id) {
      params.date_by = filters.date_by.id;
    }

    return params;
  };

  return input.map((item, index) => normalize(item.selectedFilters || {}, index));
}

function* fetchTableData() {
  yield put({ type: SET_TABLE_LOADING, payload: true });
  const {
    mainFilters: { selectedFilters },
    filtersList,
    short_url,
    organization_id
  } = yield getCommonApiParams();
  const filters = prepareQueryParams([{ selectedFilters }, ...filtersList]);

  const params = {
    filters,
    organization_id,
    short_url,
    start_from: selectedFilters.start_from.id,
    condition: selectedFilters.condition.id
  };

  try {
    let { data } = yield call(axios.post, queryParams.apiVersion + `${API_PATH}/table`, {
      ...params,
      short_url
    });

    yield put({ type: FETCH_TABLE_DATA_SUCCESS, payload: data });
    yield put({ type: SET_TABLE_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* addFiltersGroup({ payload }) {
  try {
    yield put({ type: CREATE_FILTERS_GROUP, payload: payload.start_from });
    yield fetchFilterByIndex(payload.index);
  } catch (error) {
    console.error(error);
  }
}

function* updateFilterByIndex({ payload }) {
  yield put({
    type: payload.key === "start_from" ? SET_START_FROM_BY_INDEX : SET_FILTER_BY_INDEX,
    payload
  });

  if (payload.key !== "filter_by_values") {
    yield fetchFilterByIndex(payload.index);
  }
}

function* updateMainFilter({ payload }) {
  if (payload.key === "start_from") {
    yield updateStartFrom(payload);
  } else if (payload.key !== "filter_by_values" && payload.key !== "condition") {
    yield fetchMainFilter();
  }
}

function* fetchMainFilter() {
  try {
    yield put({ type: SET_MAIN_FILTER_LOADING, payload: true });
    const {
      mainFilters: {
        selectedFilters: {
          start_from,
          filter_by,
          date_by,
          selectedRequestDates: { endDate, startDate }
        }
      },

      short_url
    } = yield getCommonApiParams();

    const params = {
      start_from: start_from.id,
      filter_by: filter_by.id,
      date_by: date_by?.id,
      end_date: endDate,
      start_date: startDate,
      short_url
    };

    let { data } = yield call(axios.post, queryParams.apiVersion + `${API_PATH}/filters`, {
      ...params
    });

    yield put({ type: FETCH_MAIN_FILTER_SUCCESS, payload: data });
    yield put({ type: SET_MAIN_FILTER_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchFilterByIndex(idx) {
  try {
    yield put({ type: SET_FILTERS_LOADING, payload: idx });
    const { filtersList, short_url } = yield getCommonApiParams();
    const {
      selectedRequestDates: { startDate, endDate },
      start_from,
      filter_by,
      date_by
    } = yield filtersList[idx].selectedFilters;

    const params = {
      start_from: start_from.id,
      filter_by: filter_by.id,
      date_by: date_by?.id,
      start_date: startDate,
      end_date: endDate,
      short_url
    };

    let {
      data: { filter_by_values }
    } = yield call(axios.post, queryParams.apiVersion + `${API_PATH}/filters`, { ...params });

    yield put({
      type: FETCH_FILTER_BY_INDEX_SUCCESS,
      payload: { index: idx, filter_by_values }
    });

    yield put({ type: SET_FILTERS_LOADING, payload: "" });
  } catch (error) {
    console.error(error);
  }
}

function* updateStartFrom(payload) {
  yield put({ type: SET_START_FROM, payload });
  yield put({ type: SET_MAIN_FILTER_LOADING, payload: true });
  try {
    yield fetchMainFilter();
    yield put({ type: SET_MAIN_FILTER_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* setDates(calendarEndDate) {
  let startDate = dayjs(calendarEndDate).startOf("month").format("YYYY-MM-DD");
  let endDate = calendarEndDate;

  yield put({ type: SET_DATES, payload: { startDate, endDate } });
}

export function* getCommonApiParams() {
  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);
  return yield select((state) => {
    const { mainFilters, filtersList } = state.leadActivity;

    return {
      organization_id: organization_id.toString(),
      short_url,
      mainFilters,
      filtersList
    };
  });
}
